import React from 'react';
import { HttpClientProvider } from './HttpClientProvider';
import { ErrorMonitorProvider } from '@wix/error-monitor/react';
import { PureExperimentsProvider } from '@wix/wix-experiments-react';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { EssentialsProvider } from './EssentialsProvider';
import { EnvironmentProvider } from './EnvironmentProvider';
import { FedopsProvider } from './FedopsProvider';
import { DataCapsuleProvider } from './DataCapsuleProvider';
import { CurrencyFormatterProvider } from './CurrencyFormatterProvider';
import { AddressFormatterProvider } from './AddressFormatterProvider';
import { PanoramaProvider } from './PanoramaProvider';
import { BILoggerProvider } from './BILoggerProvider';
import { ErrorHandlerProvider } from './ErrorHandlerProvider';
/**
 * Provides essentials conditionally to avoid providing `null` when a parent provider already exists
 */
export const EssentialsWrapperProvider = ({ essentials, children, }) => {
    const { httpClient, errorMonitor, experiments, i18n, environment, fedopsLogger, dataCapsule, createCurrencyFormatter, formatAddress, panoramaClient, biLogger, errorHandler, } = essentials.asPartial;
    let child = (React.createElement(EssentialsProvider, { value: essentials }, children));
    if (environment) {
        child = (React.createElement(EnvironmentProvider, { value: environment }, child));
    }
    if (httpClient) {
        child = React.createElement(HttpClientProvider, { value: httpClient }, child);
    }
    if (dataCapsule) {
        child = (React.createElement(DataCapsuleProvider, { value: dataCapsule }, child));
    }
    if (errorMonitor) {
        child = (React.createElement(ErrorMonitorProvider, { errorMonitor: errorMonitor }, child));
    }
    if (fedopsLogger) {
        child = React.createElement(FedopsProvider, { value: fedopsLogger }, child);
    }
    if (experiments) {
        child = (React.createElement(PureExperimentsProvider, { experiments: experiments }, child));
    }
    if (i18n) {
        child = React.createElement(I18nextProvider, { i18n: i18n }, child);
    }
    if (createCurrencyFormatter) {
        child = (React.createElement(CurrencyFormatterProvider, { value: createCurrencyFormatter }, child));
    }
    if (formatAddress) {
        child = (React.createElement(AddressFormatterProvider, { value: formatAddress }, child));
    }
    if (errorHandler) {
        child = (React.createElement(ErrorHandlerProvider, { value: errorHandler }, child));
    }
    if (panoramaClient) {
        child = React.createElement(PanoramaProvider, { value: panoramaClient }, child);
    }
    if (biLogger) {
        child = React.createElement(BILoggerProvider, { value: biLogger }, child);
    }
    return child;
};
//# sourceMappingURL=EssentialsWrapperProvider.js.map